import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function bannerMosaico() {

    // console.log('Banner Mosaico block initialized');

    const banners = document.querySelectorAll('.banner-mosaic');
    if (!banners.length) return;

    let scrollTriggers = [];

    function init() {

        // Matar ScrollTriggers anteriores
        scrollTriggers.forEach(st => st.kill());
        scrollTriggers = [];

        banners.forEach(banner => {

            const images = banner.querySelectorAll('[data-mosaic-image]');
            const container = banner.querySelector('.banner__container');

            if (!images.length || !container) return;

            // Limpiar estilos inline de GSAP para que las imágenes vuelvan al flujo natural
            gsap.set(images, { clearProps: 'all' });
            void banner.offsetHeight; // Forzar reflow

            // Capturar posiciones finales con el layout natural
            const finalPositions = [];
            images.forEach((img) => {
                const rect = img.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                finalPositions.push({
                    x: rect.left - containerRect.left,
                    y: rect.top - containerRect.top
                });
            });

            // Posicionar todas las imágenes en el centro inicialmente
            gsap.set(images, {
                position: 'absolute',
                left: '50%',
                top: '50%',
                xPercent: -50,
                yPercent: -50,
                opacity: 0,
                scale: 0.8
            });

            // Crear animación con ScrollTrigger
            const st = ScrollTrigger.create({
                trigger: banner,
                start: 'top 90%',
                once: true,
                onEnter: () => {
                    // Animar cada imagen a su posición final con stagger
                    gsap.to(images, {
                        duration: 1.2,
                        left: (index) => finalPositions[index].x,
                        top: (index) => finalPositions[index].y,
                        xPercent: 0,
                        yPercent: 0,
                        opacity: 1,
                        scale: 1,
                        ease: 'power3.out',
                        stagger: 0.1
                    });
                }
            });
            scrollTriggers.push(st);
        });
    }

    init();

    // En resize: limpiar estilos, recapturar posiciones y reiniciar animaciones
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(init, 300);
    });

}

export default bannerMosaico;